import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../constants';

const ContattiPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '', tipo: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try { await axios.post(`${API}/contact`, formData); } catch (e) {}
    setSubmitted(true);
  };

  return (
    <main data-testid="contatti-page" className="pt-24">
      <section className="py-24">
        <div className="max-w-4xl mx-auto px-6">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">Contatti</p>
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-8">Parliamo.</h1>

          <div className="grid md:grid-cols-2 gap-16">
            <div>
              <div className="space-y-6">
                <div>
                  <h3 className="font-mono text-xs uppercase tracking-wider text-[#00FF41] mb-2">Email</h3>
                  <p className="text-zinc-300">info@aicovo.it</p>
                </div>
                <div>
                  <h3 className="font-mono text-xs uppercase tracking-wider text-[#00FF41] mb-2">Sede</h3>
                  <p className="text-zinc-300">Colle Val d'Elsa (SI)<br />Toscana, Italia</p>
                </div>
              </div>
            </div>

            <div>
              {submitted ? (
                <div className="bg-[#00FF41]/10 border border-[#00FF41]/30 p-8 text-center">
                  <p className="text-[#00FF41] font-bold text-xl mb-2">Inviato!</p>
                  <p className="text-zinc-400">Ti risponderemo presto.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <input type="text" required placeholder="Nome" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} className="w-full bg-[#0A0A0A] border border-white/10 px-4 py-3 text-white focus:outline-none focus:border-[#00FF41]" />
                  <input type="email" required placeholder="Email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} className="w-full bg-[#0A0A0A] border border-white/10 px-4 py-3 text-white focus:outline-none focus:border-[#00FF41]" />
                  <textarea required rows={5} placeholder="Messaggio" value={formData.message} onChange={(e) => setFormData({...formData, message: e.target.value})} className="w-full bg-[#0A0A0A] border border-white/10 px-4 py-3 text-white focus:outline-none focus:border-[#00FF41] resize-none" />
                  <button type="submit" className="btn-primary w-full">Invia</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContattiPage;
